import { ROUTES } from "@/constants/routes";
import { useAppNavigate } from "@/hooks/pane-routing";
import { route } from "@/utils/route";
import { useCallback } from "react";

/** Opens `AutomationPane` for an automation id (`"new"` for create mode) in the right pane. */
export function useOpenAutomation() {
  const appNavigate = useAppNavigate();

  return useCallback(
    (automationId: string) => {
      if (!automationId) return;
      appNavigate({
        pane: "rightPane",
        to: route(ROUTES.AUTOMATIONS.SHOW, { id: automationId }),
      });
    },
    [appNavigate],
  );
}
